import { ClinicalTaskSource } from './clinical-task-source.enum';
import { PinnedProperties } from '../clinical.model';

export { ClinicalTaskSource };
export interface ClinicalTask {
  taskID?: string;
  assignee_id?: string;
  assigneeName?: string;
  creator_id?: string;
  patient_id?: string;
  patientName?: string;
  client_id?: string;
  completed?: boolean;
  create_date?: any;
  due_date?: any;
  last_update?: any;
  task_description?: string;
  task_name?: string;
  task_name_lower?: string;
  patient_name?: string;
  patient_name_lower?: string;
  client_name?: string;
  client_name_lower?: string;
  clinical_task_notes?: any[];
  id?: string;
  completed_by?: string;
  last_updated_by?: string;
  priority?: 'low' | 'medium' | 'high' | 'critical'; // AI-determined priority level
  priority_score?: number; // 1-10 scale
  priority_reasoning?: string;
  pinned?: boolean;
  pinnedProperties?: PinnedProperties;
  type?: string; // display label, e.g. 'Missed Call' | 'Post-hospitalization outreach'
  task_source?: ClinicalTaskSource; // provenance, e.g. automation vs. manual create
  auto_closed?: boolean; // set when an automation auto-closes the task (e.g. patient discharged)
  cancellation_reason?: string; // free-text reason captured when a task is cancelled
  apcm_tier?: string;
  review_notes?: string;
  review_action?: 'approve' | 'reject';
}

export interface ClinicalTaskNote {
  author_id?: string;
  create_date?: Date;
  text?: string;
}

type OrderByDirection = 'asc' | 'desc';

export interface ClinicalTaskListRequest {
  page?: number;
  pageSize?: number;
  providerId: string;
  searchParams: SearchClinicalTasksParams;
  groupByPatient?: boolean;
}

export interface ClinicalTaskListResponse {
  page: number;
  pageSize: number;
  totalRecords: number;
  records: ClinicalTask[];
}

export interface SearchClinicalTasksParams {
  patientId?: string;
  isCompleted?: boolean;
  startDate?: Date;
  endDate?: Date;
  sortByField?: string;
  sortDirection?: OrderByDirection; // 'asc' | 'desc'
  assigneeId?: string;
  creatorId?: string;
}

export interface ClinicalTaskRequest {
  page: number;
  pageSize: number;
  isCompleted?: boolean;
  client_accounts: string[];
  assignee_id?: string;
  startDate?: Date;
  endDate?: Date;
  groupByPatient?: boolean;
}
